import { UncAddR1Window } from '@root-gipro/modules/userProjects/components/Project/Modal'
import { ISelectTableHeader } from '@root-gipro/modules/userProjects/models/interfaces/project-unc-add.props'
import React, { useCallback, useContext, useEffect, useState } from 'react'

import { ModalContext } from '@root-gipro/context/modal-context'
import { ToggleTabs } from '@root-gipro/modules/userProjects/components/Project/UncAdd/ToggleTabs'
import { SecondaryBtn } from '@root-gipro/shared/Button/Button'

import { showNotify } from '@root-gipro/modules/notify/store/actions'
import { tbodyArr } from '@root-gipro/modules/userProjects/models/consts/unc-tbody.const'
import { changeUncCheckedTable } from '@root-gipro/modules/userProjects/store/actions'
import { IState } from '@root-gipro/store/interfaces'
import { useDispatch, useSelector } from 'react-redux'

const blockedWithAutoAddUncIds = [231, 315, 316, 317, 318, 319, 320]

export const SelectTableHeader: React.FC<ISelectTableHeader> = ({
	uncTableData,
	setChecked,
	selectedElem,
	tableNums,
	tableTitles,
	checkedTable,
	setShowInter,
	showInter,
	createSpecialUnc,
}) => {
	const dispatch = useDispatch()
	const { setAnchorEl, anchorEl } = useContext(ModalContext)
	const [blockAddUnc, setBlockAddUnc] = useState(false)

	const { originalObj } = useSelector((state: IState) => state.userProjects)

	useEffect(() => {
		if (selectedElem) {
			const blockedUncTable = blockedWithAutoAddUncIds.includes(selectedElem.id)
			setBlockAddUnc(blockedUncTable && originalObj.unc_auto_add)
		}
	}, [selectedElem])

	const items = tbodyArr
		.filter(item => {
			if (selectedElem?.code === 'С1') {
				return item.addUncShowing
			} else {
				return item.tableNum !== 8 && item.tableNum !== 6
			}
		})
		.map(item => {
			return {
				name: item.title,
				value: item.tableNum + '',
			}
		})
	const openWindow = useCallback(
		(e: React.MouseEvent<HTMLElement>) => {
			if (blockAddUnc) {
				dispatch(
					showNotify({
						type: 'warning',
						message: `Расценка не добавлена, т.к. включен режим авторасстановки ПИР, Б1-С1`,
					})
				)
				return
			} else {
				setAnchorEl!(e.currentTarget)
			}
		},
		[setAnchorEl, blockAddUnc]
	)

	return (
		<div className='select-table__header wrapper__toggler'>
			<ToggleTabs
				defaultValue={selectedElem?.code === 'С1' ? items.length - 1 : checkedTable >= 6 ? 0 : checkedTable - 1}
				items={items}
				clickHandler={item => {
					setChecked(item.value)
					dispatch(changeUncCheckedTable(Number(item.value)))
				}}
				selectedElemCode={selectedElem?.code}
			/>
			{uncTableData && uncTableData.interpolation > 0 && selectedElem?.code !== 'Б1' && (
				<div className='interpol_wrapper ml-8'>
					<SecondaryBtn data-popup='unc-add-r1' onClick={openWindow}>
						Задать
					</SecondaryBtn>
					{anchorEl?.dataset.popup === 'unc-add-r1' && (
						<UncAddR1Window
							handler={createSpecialUnc}
							data={uncTableData.selects}
							tableId={uncTableData.id}
							anchorEl={anchorEl!}
							setAnchorEl={setAnchorEl!}
						/>
					)}
				</div>
			)}
		</div>
	)
}
